import $ from 'jquery';
import { buildSlider } from '../utils/slider';

export default ($bulletLists) => {
    $bulletLists.each((i, el) => {
        const $carousel = $(el).find('.bullet-list__carousel');

        if (!$carousel.length) {
            return;
        }

        const $track = $carousel.find('.bullet-list__carousel__slides');
        const $dots = $carousel.find('.bullet-list__carousel__dots');
        const $arrows = $carousel.find('.bullet-list__carousel__arrows');

        const buttonPrev =
            '<button data-cta-type="carousel" data-cta-desc="Previous month" class="bullet-list__carousel__btn cta --prev"><span class="-hide-text">Previous</span><span class="icon-arrow-thick-left"></span></button>';
        const buttonNext =
            '<button data-cta-type="carousel" data-cta-desc="Next month" class="bullet-list__carousel__btn cta --next"><span class="-hide-text">Next</span><span class="icon-arrow-thick-left"></span></button>';

        const options = {
            slidesToShow: 1,
            fade: true,
            dots: true,
            infinite: true,
            adaptiveHeight: false,
            appendDots: $dots,
            appendArrows: $arrows,
            prevArrow: buttonPrev,
            nextArrow: buttonNext,
        };

        function setButtonAttributes() {
            const total = $('.bullet-list__slide').length;
            const current = parseInt(
                $('.bullet-list__slide.slick-active').attr('data-slick-index'),
            );
            const prev = !current ? total - 1 : current - 1;
            const next = current + 1 === total ? 0 : current + 1;
            $arrows.find('button').each(function () {
                if ($(this).hasClass('--prev')) {
                    $(this).attr('data-previous-month', prev);
                } else if ($(this).hasClass('--next')) {
                    $(this).attr('data-next-month', next);
                }
            });
        }

        $track.on('init', () => {
            $dots.find('button').each((i, el) => {
                $(el).addClass('cta');
                $(el).attr('data-cta-type', 'carousel');
                $(el).attr('data-cta-desc', `Month ${i + 1}`);
            });
            setButtonAttributes();
        });

        $track.on('afterChange', function () {
            setButtonAttributes();
        });

        buildSlider($track, options);
    });
};
